import GnbCheckerBoardMenu from './GnbCheckerBoardMenuContainer';

export default GnbCheckerBoardMenu;
